export default "__VITE_PUBLIC_ASSET__a1d34799__"